import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@components/info-tooltip/info-tooltip.tsx';
import MediaLibraryComponent from '@components/media-library-component/media-library-component.tsx';
import { FileTypeEnum } from '@models/media-library.model.ts';
import useMediaLibraryStore from '@store/media-library-store/media-library.store.ts';

function MediaLibrary() {
  const { t } = useTranslation();

  const [selectedMedia, setSelectedMedia] = useState<Record<string, any>>({});
  const { resetAllSelectedMedia } = useMediaLibraryStore();

  useEffect(() => {
    return () => {
      const timeout = setTimeout(() => {
        resetAllSelectedMedia();
      }, 500);

      clearTimeout(timeout);
    };
  }, [resetAllSelectedMedia]);

  return (
    <div className="flex flex-col gap-8">
      {/* Header text describing the purpose */}
      <div>
        <h2 className="text-lg font-semibold text-gray-800 mb-1">
          🗂️ Media Library UI Kit
        </h2>
        <p className="text-sm text-gray-600">
          This component demonstrates how to add and select media files:
          <strong> images, audio, and other file types.</strong>
        </p>
      </div>

      {/* Actual examples */}
      <div className="flex flex-wrap gap-6">
        {/* 🖼️ Image selector */}
        <div className="media-wrapper">
          <div className="flex mb-1.5">
            <span className="required-symbole">*</span>
            {t('label_image')}
          </div>
          <MediaLibraryComponent
            mediaKey="uiKitImage"
            allowedTypes={[FileTypeEnum.Image]}
            path="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg"
            onSelect={(media) =>
              setSelectedMedia((prev) => ({ ...prev, uiKitImage: media }))
            }
          />
        </div>

        {/* 🎵 Audio selector */}
        <div className="media-wrapper mb-3">
          <div className="flex mb-1.5">
            <span className="required-symbole">*</span>
            {t('label_music_file')}
            <InfoTooltip text="tooltip_info_music_file" />
          </div>
          <MediaLibraryComponent
            mediaKey="uiKitAudio"
            title="upload_audio_content_text"
            allowedTypes={[FileTypeEnum.Audio]}
            onSelect={(media) =>
              setSelectedMedia((prev) => ({ ...prev, uiKitAudio: media }))
            }
          />
        </div>

        {/* 🖼️ Another image selector (no default path) */}
        <div className="media-wrapper">
          <div className="flex mb-1.5">
            <span className="required-symbole">*</span>
            {t('label_music_cover_image')}
            <InfoTooltip text="tooltip_info_music_cover_image" />
          </div>
          <MediaLibraryComponent
            mediaKey="uiKitImage2"
            allowedTypes={[FileTypeEnum.Image]}
            onSelect={(media) =>
              setSelectedMedia((prev) => ({ ...prev, uiKitImage2: media }))
            }
          />
        </div>

        <div className="media-wrapper">
          <div className="flex mb-1.5">
            <span className="reuqired-symbole">*</span>
            {t('label_channel_image')}
            <InfoTooltip text="tooltip_info_live_tv_channel_image" />
          </div>

          <MediaLibraryComponent
            mediaKey={'uiKitLogo'}
            width={240}
            height={120}
            allowedTypes={[FileTypeEnum.Image]}
            // path={selectedItem?.image}
            onSelect={(media) =>
              setSelectedMedia((prev) => ({ ...prev, uiKitLogo: media }))
            }
          />
        </div>
      </div>
    </div>
  );
}

export default MediaLibrary;
